<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '90%', maxWidth: '450px' }"
  (onHide)="onClose()"
>
  <ng-template pTemplate="header">
    <div class="flex items-center gap-3">
      <div
        class="flex h-12 w-12 items-center justify-center rounded-full bg-primary-50 text-primary-500"
      >
        <i class="pi pi-file-pdf text-2xl"></i>
      </div>
      <span class="text-xl font-semibold text-greyscale-900">{{
        "companyReport.title" | transloco
      }}</span>
    </div>
  </ng-template>

  <div class="flex flex-col gap-4">
    <p class="text-sm text-greyscale-600">
      {{ "companyReport.description" | transloco }}
    </p>

    <!-- Report language -->
    <div class="flex flex-col gap-2">
      <label
        for="company-report-lang"
        class="text-sm font-medium text-greyscale-700"
        >{{ "companyReport.language" | transloco }}</label
      >
      <p-select
        inputId="company-report-lang"
        [options]="langs"
        [(ngModel)]="selectedLang"
        optionLabel="label"
        optionValue="value"
        styleClass="w-full"
        appendTo="body"
      />
    </div>

    <!-- Period filter -->
    <div class="flex flex-col gap-2">
      <label
        for="company-report-period"
        class="text-sm font-medium text-greyscale-700"
        >{{ "companyReport.period" | transloco }}</label
      >
      <p-select
        inputId="company-report-period"
        [options]="years()"
        [(ngModel)]="selectedYear"
        optionLabel="label"
        optionValue="value"
        styleClass="w-full"
        appendTo="body"
      />
    </div>

    <!-- Client filter -->
    <div class="flex flex-col gap-2">
      <label
        for="company-report-client"
        class="text-sm font-medium text-greyscale-700"
        >{{ "companyReport.client" | transloco }}</label
      >
      @if (packLimitationService.canFilterClient()) {
        <p-select
          inputId="company-report-client"
          [options]="clients()"
          [(ngModel)]="selectedClient"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
          appendTo="body"
        />
      } @else {
        <app-locked-button
          [label]="'companyReport.filterClient' | transloco"
          [limitedFeature]="limitedFeature"
          [fluid]="true"
        />
      }
    </div>

    <!-- Trip counter -->
    <div class="rounded-lg bg-greyscale-50 p-3 text-sm text-greyscale-600">
      <i class="pi pi-file mr-2"></i>
      {{ tripCount }} {{ "companyReport.tripsMatch" | transloco }}
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'companyReport.notNow' | transloco"
        [text]="true"
        severity="secondary"
        (onClick)="onClose()"
      />
      <p-button
        [label]="'companyReport.download' | transloco"
        icon="pi pi-download"
        (onClick)="download()"
        [loading]="isDownloading()"
      />
    </div>
  </ng-template>
</p-dialog>
